import { Route } from '@angular/router';
import { BanksListComponent } from './ui/banks-list/banks-list.component';
import { BankFormComponent } from './ui/bank-form/bank-form.component';

const banksRoutes: Route[] = [
    {
        path: 'banks',
        component: BanksListComponent,
    },
    {
        path: 'banks/new',
        component: BankFormComponent,
    },
    {
        path: 'banks/:id/edit',
        component: BankFormComponent,
    },
];

export default banksRoutes;
